import React, { useEffect, useRef, useState } from "react";
import pageHeadingStyles from "../../../styles/PageHeader.module.scss";
import styles from "./styles.module.scss";
import SearchInput from "../../../components/SearchInput/SearchInput";
import ButtonIcon from "../../../components/ButtonIcon/ButtonIcon";
import useMccStore from "../../../stores/mcc";
import PlusIcon from '../../../assets/svg/icons/common/Plus'

const Header = () => {
  const [searchValue, setSearchValue] = useState("");

  const setSearchFilters = useMccStore((state) => state.setSearchFilters);
  const searchFilters = useMccStore((state) => state.searchFilters);
  const setIsAddMCCModalOpen = useMccStore((state) => state.setIsAddMCCModalOpen);
  const setSelectedMcc = useMccStore((state) => state.setSelectedMcc);

  const timerRef = useRef(null);

  const handleChange = (e) => {
    setSearchValue(e.target.value);
    setSelectedMcc([]);
  };

  const handleAddCodes = () => {
    setIsAddMCCModalOpen(true);
  };

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setSearchFilters({
        ...searchFilters,
        search: searchValue
      });
    }, 300);

    return () => {
      clearTimeout(timerRef.current);
    };
  }, [searchValue]);

  return (
    <div className={pageHeadingStyles.page_heading}>
      <div className={pageHeadingStyles.title_contents}>
        <p>MCC Codes</p>
      </div>
      <div className={styles.right_side}>
        <SearchInput value={searchValue} onChange={handleChange} />
        <ButtonIcon bgColor="#4C70EF" textColor="#FFF" onClick={handleAddCodes}>
          <PlusIcon />
          <span>
            Add Code
          </span>
        </ButtonIcon>
      </div>
    </div>
  );
};

export default Header;
